// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import PlanUpgrade from "../PlanUpgrade";
import { IMAGE_URLS } from "../../constants";

const { UPLOAD_IMG } = IMAGE_URLS;

const DocumentSettingsUpgrade = props => (
  <Fragment>
    <div className="attachment-container animated fadeinright">
      <div className="attachment-header">
        <span>Settings</span>
      </div>
      <div className="attachment-body-wrapper">
        <div className="content-scroll">
          <div className="attachment-box-upgrade">
            <div className="attachment-upload-section">
              <img
                src={UPLOAD_IMG}
                className="attachment-upload-image"
                alt="attachment"
                height="85px"
                width="160px"
              />
            </div>
          </div>
          <div className="attachment-upgrade-container">
            <div className="attachment-upgrade-txt">
              {props.isSharedDocument
                ? "Contact the document sender to enable Attachments Upload relevant files such as identity proofs, brochures, anexures, audio or video as attachments for this document."
                : "To add attachments and collaborate with recipients, upgrade to premimum plan"}
            </div>
            <PlanUpgrade
              isSharedDocument={props.isSharedDocument}
              type={props.featureName}
            />
          </div>
        </div>
        <PlanUpgrade
          isSharedDocument={props.isSharedDocument}
          type={props.featureName}
        />
      </div>
    </div>
  </Fragment>
);

export default DocumentSettingsUpgrade;
